import moment from 'moment';
import { useState, useEffect } from 'react';
import Loader from '../../../Tools/Loader';
import EnrollForm from './Form';
import { Button, Table, TableContainer, TableHead, TableRow, TableBody, TableCell, Paper, IconButton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import UncheckIcon from '@mui/icons-material/Close';
import Kpis from './Kpis.js';
import Flex from '../../../Tools/Flex.js';
import Documents from './Documents.js';
import Actions from './Actions.js';
import ZoomIcon from '@mui/icons-material/ZoomIn';
import { useNavigate } from 'react-router-dom';
import API from '../../../../services/API.js';
import { Download } from '@mui/icons-material';
import EnrollmentCashing from '../../EnrollmentCashing.js';

export default function List({person}){

    const [enrollments, setEnrollments] = useState(false);
    const [modal, setModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {

        API.get(`/crm/users/${person.id}/enrollments`)
            .then(r => setEnrollments(r.data))
            .catch(e => console.log(e.response.data))

    }, [person])


    const handleNew = enrollment => {
        let copy = [...enrollments];
        copy.unshift(enrollment);
        setEnrollments(copy);
        return setModal(false);
    }


    const handleDelete= id => {

        if( !window.confirm("Êtes-vous sûr de vouloir supprimer cette inscription ?") ) return false;

        const old = [...enrollments];

        API.delete(`/crm/enrollments/${id}`)
            .then(r => console.log(r.data))
            .catch(e => setEnrollments(old))

        setModal(false)

        let copy = [...enrollments];
        copy = copy.filter(e => e.id !== id);

        setModal(false);
        return setEnrollments(copy);
    }


    const handlePay = (id) => {
        if( !window.confirm("Êtes-vous sûr de vouloir marquer cette inscription comme payée ?") ) return false;

        API.put(`/crm/enrollments/${id}/paid`)
            .then(r => reload())
            .catch(e => setEnrollments([...enrollments]))

        setModal(false);
        return false;
    }

    const handleComplete = (id) => {
        if( !window.confirm("Êtes-vous sûr de vouloir marquer cette inscription comme terminée ?") ) return false;

        API.put(`/crm/enrollments/${id}/complete`)
            .then(r => reload())
            .catch(e => setEnrollments([...enrollments]))

        setModal(false);
        return false;
    }

    const handleOwnerChange = (id) => {
        const email = window.prompt("Entrez l'adresse email du bon compte LearnyLib :");

        if( !email) return false;

        API.put(`/crm/enrollments/${id}/user/change`, {email})
            .then(r => reload())
            .catch(e => setEnrollments([...enrollments]))

        setModal(false);
        return false;
    }

    const reload = () => {

        API.get(`/crm/users/${person.id}/enrollments`)
            .then(r => setEnrollments(r.data))
            .catch(e => console.log(e.response.data))

        return false;
    }

    const handleChange = item => {
        const old = [...enrollments]

        let copy = [...enrollments].filter(i => i.id !== item.id)
        copy.push(item)
        setEnrollments(copy)

        API.put(`/crm/enrollments/${item.id}`, item)
            .catch(_ => setEnrollments(old))
    }

    const handleLogsClick = item => {
        API.download(`/study/enrollments/${item.id}/logs/doc.pdf`)
    }

    const handleQuizClick = (item) => {
        API.download(`/crm/enrollments/${item.id}/quiz.csv`)
    }


    if(!enrollments) return <Loader />

    return <>

        <Flex justifyContent='space-between' alignItems='end'>

            <Kpis enrollments={enrollments} person={person} />
        
            <Button variant='contained' onClick={() => setModal({action: 'enroll'})} >
                Inscrire
            </Button>
        
        </Flex>

            
        {enrollments.length > 0 && 
            <TableContainer component={Paper} variant='outlined'>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Formation</TableCell>
                            <TableCell>P.I.</TableCell>
                            <TableCell>Date</TableCell>
                            <TableCell>Type</TableCell>
                            <TableCell>Montant</TableCell>
                            <TableCell>Complétion</TableCell>
                            <TableCell>DPC</TableCell>
                            <TableCell>Documents</TableCell>
                            <TableCell>Quiz</TableCell>
                            <TableCell>Logs</TableCell>
                            <TableCell>Actions</TableCell>
                            <TableCell>Participation</TableCell>
                            <TableCell>DDS</TableCell>
                            <TableCell>Commercial</TableCell>
                            <TableCell>Encaissé le</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    
                    {enrollments
                        .sort((a,b) => b.createdAt > a.createdAt ? 1 : -1)   
                        .map(e => 
                            <TableRow data-id={e.id} key={e.id}>
                                <TableCell>{e.course.title}</TableCell>
                                <TableCell>{e.pi ?
                                    <CheckIcon color='info' fontSize='small'/> :
                                    <UncheckIcon color='error' fontSize='small' />}
                                </TableCell>
                                <TableCell>{moment(e.createdAt).format('DD/MM/YYYY à HH:mm')}</TableCell>
                                <TableCell>{e.type.title}</TableCell>
                                <TableCell>{e.amount.toLocaleString()}€</TableCell>
                                <TableCell>{e.completion.toLocaleString()}%</TableCell>
                                <TableCell>{e.dpc && e.dpc.title}</TableCell>
                                <TableCell align='center'>
                                    {e.docs?.length > 0 && <Zoom onClick={() => setModal({action: 'docs', enrollment: e})}/>}
                                </TableCell>
                                <TableCell align='center'>
                                    <IconButton size="small" onClick={() => handleQuizClick(e)}>
                                        <Download />
                                    </IconButton>
                                </TableCell>
                                <TableCell align='center'>
                                    <IconButton size="small" onClick={() => handleLogsClick(e)}>
                                        <Download />
                                    </IconButton>
                                </TableCell>
                                <TableCell align='center'>
                                    <Zoom onClick={() => setModal({action: 'action', enrollment: e})}/>
                                </TableCell>
                                <TableCell align='center'>
                                    {e.dpc && 
                                        <Zoom onClick={() => navigate(`/dpc/participation/${e.dpc?.id}`)}/>
                                    }
                                </TableCell>
                                <TableCell>{e.dpc?.status?.title}</TableCell>
                                <TableCell>{e.wonBy && e.wonBy.name}</TableCell>
                                <TableCell>
                                    <EnrollmentCashing enrollment={e} onChange={handleChange} />
                                </TableCell>
                            </TableRow>    
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        }



        <EnrollForm 
            open={modal?.action === 'enroll'}
            onClose={() => setModal(false)} 
            person={person} 
            onCreate={data => handleNew(data)}
        />

        <Documents 
            open={modal?.action === 'docs'}
            onClose={() => setModal(false)}
            enrollment={modal?.enrollment}
        />

        <Actions
            open={modal?.action === 'action'}
            onClose={() => setModal(false)}
            enrollment={modal?.enrollment}
            onPay={id => handlePay(id)}
            onComplete={id => handleComplete(id)}
            onOwnerChange={id => handleOwnerChange(id)}
            onDelete={id => handleDelete(id)}
        />

    </>
}




function Zoom({onClick}){
    
    return <IconButton size='small' onClick={onClick}>
        <ZoomIcon />
    </IconButton>
}
